import PropTypes from 'prop-types';
import React, { useContext } from 'react';
// import InputMask from 'react-input-mask';
import MaskedInput from 'react-maskedinput';
import { PHONE_NUMBER_MASK, FORMATTED_PHONE_NUMBER_REGEX } from 'constants/index';
import DisabledContext from 'antd/lib/config-provider/DisabledContext';

export default function PhoneNumber({ noStyle, value, onChange, readOnly, ...rest }) {
  const onValueChange = (e) => {
    let value = e.target.value;
    if (FORMATTED_PHONE_NUMBER_REGEX.test(value)) {
      value = `+1${value.replace(/\(|\)|\s|\-|\_/g, '')}`;
    }
    onChange(value);
  };
  let formattedValue = value;
  if (!value) formattedValue = '';
  if (/^\+1/.test(value)) {
    formattedValue = value.slice(2);
  }

  const isFormDisabled = useContext(DisabledContext);
  const isDisabled = rest?.disabled || isFormDisabled;

  return (
    <MaskedInput
      type="tel"
      {...rest}
      disabled={isDisabled}
      value={formattedValue}
      onChange={onValueChange}
      className="ant-input"
      mask={PHONE_NUMBER_MASK}
      placeholderChar="X"
      readOnly={readOnly}
      style={{ borderRadius: '0px' }}
      aria-label="phone number"
    />
  );
}

PhoneNumber.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};
